import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useOutletContext } from "react-router-dom";
import {
  fetchShows,
  showsAndRoomsSliceSelector,
} from "../../../../redux/features/showsAndRoomsSlice";

const Shows = () => {
  const { organization } = useOutletContext();
  const { id: organizationId } = organization || {};
  const dispatch = useDispatch();
  const showsState = useSelector((state) => showsAndRoomsSliceSelector(state));
  const { showsLoading, showsFetched } = showsState || {};

  useEffect(() => {
    if (organization && organizationId && !showsLoading && !showsFetched) {
      dispatch(fetchShows({ organizationId }));
    }
  }, [dispatch, organizationId, organization, showsLoading, showsFetched]);

  if (!organization) {
    return;
  }

  return (
    <Box>
      <Outlet context={{ organization: organization }} />
    </Box>
  );
};

export default Shows;
